import { HostFloorPlanTable } from 'restaurantAdmin/floorPlans/apiHelpers';
import { Card } from '@components/card/Card';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './SeatingSelectedTables.scss';

export const SeatingSelectedTables = ({
  className,
  floorPlanTables,
}: {
  className?: string;
  floorPlanTables: HostFloorPlanTable[];
}) => {
  return (
    <Card bordered className={cx(styles.container, className)}>
      <div className={cx(typography.h5, styles.tableCount)}>
        {floorPlanTables.length}{' '}
        <span className={cx(typography.t3_12, styles.label)}>Table(s)</span>
      </div>
      <div className={typography.c3_20}>
        {floorPlanTables.map(({ name }) => name).join(', ') ||
          'No table selected'}
        <div className={cx(typography.t2, styles.instructions)}>
          You can select multiple tables.
        </div>
      </div>
    </Card>
  );
};
